
export default {

    ...{
        LOADING (state, payload = true) {
            state.app.loading = payload
        },
        UPDATE_FILTERS (state, payload) {
            console.log('UPDATE_FILTERS: ', state, payload)
            state.filters = {...state.filters, ...payload}
        },
        SET_PRODUCT_LIST (state, payload) {
            console.log('SET_PRODUCT_LIST: ', state, payload)
            state.products.items = payload.products || []
            state.products.total = payload.total
        },
        OPEN_MODAL (state, payload) {
            state.app.openModal = payload
        },
        TOGGLE_ORDER_POPUP (state, payload) {
            state.app.orderProduct = payload
        }
    }
}
